import { create } from 'zustand';
import { IKioskFields, TKioskStore } from './type';
import { kioskInstitutionSlice } from './kioskInstitution.slice';
import { authApi } from '@/API';
import { convertKeys } from '@/utils/common';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';
import { kioskAppointmentsSlice } from './kioskAppointments.slice';
import { kioskDashboardControlSlice } from './kioskDashboardControl.slice';

const initialState: IKioskFields = {
  kioskData: null,
};

export const useKioskStore = create<TKioskStore>()((set, get, ...arg) => ({
  ...kioskInstitutionSlice(set, get, ...arg),
  ...kioskAppointmentsSlice(set, get, ...arg),
  ...kioskDashboardControlSlice(set, get, ...arg),
  ...initialState,
  authKiosk: async (body) => {
    try {
      const response = await authApi.postAuthKiosk(convertKeys(body, 'snake'));
      const data = convertKeys(response.data.data);
      localStorage.setItem(LOCAL_STORAGE_KEYS.KIOSK_TOKEN, data.accessToken);
      localStorage.setItem(LOCAL_STORAGE_KEYS.KIOSK_ID, data.id);
    } catch (error) {
      console.error('Login with password failed:', error);
      throw error;
    }
  },
  clearKiosk: () => set(initialState),

  setKioskData: (kioskData) => {
    set({ kioskData });
  },
}));
